import { isElementAboveViewport } from '~/utils/positionOnScreen/isElementAboveViewport';
import { isElementBelowViewport } from '~/utils/positionOnScreen/isElementBelowViewport';

export function isElementInViewport(element, range) {
  if (!element) {
    return false;
  }

  const isBelow = isElementBelowViewport(element, range);
  const isAbove = isElementAboveViewport(element, -range);

  return !isBelow && !isAbove;
}
